<template>
  <div class="ship-units ship-address-box">
    <h4 class="integrated-shipment-headers">Delivery Addresses</h4>
    <div v-if="orderInfo">
      <div class="tabs">
        <div
          v-on:click="activate('shipTo', $event)"
          class="tab"
          :class="[this.state === 'shipTo' ? 'active-tab' : '']"
        >
          <p>Ship To</p>
        </div>
        <div
          v-on:click="activate('shipFrom', $event)"
          class="tab"
          :class="[this.state === 'shipFrom' ? 'active-tab' : '']"
        >
          <p>Ship From</p>
        </div>
      </div>
      <div class="address-info">
        <div v-if="state === 'shipTo'" class="ship-units">
          <div class="address-container">
            <div>
              <span>ATTN:</span>
              <input
                id="atn-line"
                type="text"
                @input="updateAtn"
                :value="orderInfo.ship_to.contact_name"
              />
            </div>
            <div>
              <span>Name:</span>
              <p>{{ orderInfo.ship_to.name }}</p>
            </div>
            <div>
              <span>Phone Number</span>
              <input
                id="phone-number"
                type="text"
                @input="updatePhone"
                :value="orderInfo.ship_to.phone_number"
              />
            </div>
            <div>
              <span>Address:</span>
              <p>{{ orderInfo.ship_to.address_line_1 }}</p>
            </div>
            <div>
              <span>Address:</span>
              <p>{{ orderInfo.ship_to.address_line_2 }}</p>
            </div>
            <div>
              <span>City, State:</span>
              <p>{{ orderInfo.ship_to.city }}, {{ orderInfo.ship_to.state }}</p>
            </div>
            <div>
              <span>Zip:</span>
              <p>{{ orderInfo.ship_to.zip }}</p>
            </div>
            <div>
              <span>Country Code</span>
              <p>{{ orderInfo.ship_to.country }}</p>
            </div>
          </div>
        </div>
        <div v-else class="ship-units">
          <div class="address-container">
            <div>
              <span>Name:</span>
              <p>{{ orderInfo.ship_from.name }}</p>
            </div>
            <div>
              <span>Phone Number:</span>
              <p>{{ orderInfo.ship_from.phone_number }}</p>
            </div>
            <div>
              <span>Address:</span>
              <p>{{ orderInfo.ship_from.address_line_1 }}</p>
            </div>
            <div>
              <span>Address:</span>
              <p>{{ orderInfo.ship_from.address_line_2 }}</p>
            </div>
            <div>
              <span>City, State:</span>
              <p>
                {{ orderInfo.ship_from.city }}, {{ orderInfo.ship_from.state }}
              </p>
            </div>
            <div>
              <span>Zip:</span>
              <p>{{ orderInfo.ship_from.zip }}</p>
            </div>
            <div>
              <span>Country Code</span>
              <p>{{ orderInfo.ship_from.country }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="empty-container"></div>
      <div class="ship-units">
        <div class="address-container">
          <div>
            <span>Name:</span>
          </div>
          <div>
            <span>Address:</span>
          </div>
          <div>
            <span>Address:</span>
          </div>
          <div>
            <span>City, State:</span>
          </div>
          <div>
            <span>Zip:</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      state: "shipTo",
    };
  },
  methods: {
    activate: function (newState, $event) {
      this.state = newState;
    },
    updateAtn: function (e) {
      this.$emit("updatedAtn", e.target.value);
    },
    updatePhone: function (e) {
      this.$emit("updatedPhone", e.target.value);
    },
  },
  props: ["orderInfo", "title"],
};
</script>

<style scoped>
.ship-address-box {
  width: 33%;
  box-sizing: border-box;
  border: solid black 1px;
  padding: 20px;
  height: 337px;
}

h4 {
  margin: -20px;
  margin-bottom: 0.5rem;
}
.shipping-info-box {
  border-top: 1px solid lightgray;
}

.address-info {
  border-top: 1px solid lightgray;
}
.tabs {
  overflow: hidden;
  margin: 0 0 -1px 0;
  display: flex;
  justify-content: space-between;
  width: 50%;
  color: white;
}
.tab {
  background-color: lightgray;
  border: lightgray solid 1px;
  border-bottom: none;
  font-weight: 600;
  padding: 7px 1px 0px;
  text-align: center;
  width: 50%;
  cursor: pointer;
}
.active-tab {
  color: #ffffff;
  background-color: #82b83b;
  border-bottom: 1px solid #000;
}
.address-container {
  outline: solid 0.5px #ccc;
}
.address-container h6 {
  line-height: 20px;
}
.address-container div {
  border-bottom: solid 0.5px #ccc;
  display: flex;
  padding: 2px 5px;
}
.address-container div span {
  color: #ccc;
  width: 26%;
  margin-right: 0.5rem;
}
.address-container div p {
  margin: 0;
}
.address-container div:last-child {
  border: none;
}
</style>
